import * as React from 'react';
import { tv, type VariantProps } from '@benepass/tailwind-config-web/tailwind-variants';
import { cn } from '../../utils';

const footerStyles = tv({
  base: ['flex items-center justify-end gap-3', 'pt-4 mt-4 border-t border-grayscale-20', 'px-7 pb-7'],
  variants: {
    align: {
      start: 'justify-start',
      center: 'justify-center',
      end: 'justify-end',
      between: 'justify-between',
    },
  },
  defaultVariants: {
    align: 'end',
  },
});

export type FooterProps = Omit<React.HTMLAttributes<HTMLDivElement>, 'className'> & VariantProps<typeof footerStyles>;

const Footer: React.ForwardRefExoticComponent<FooterProps & React.RefAttributes<HTMLDivElement>> = React.forwardRef<
  HTMLDivElement,
  FooterProps
>(({ ...props }, ref) => <div ref={ref} className={cn(footerStyles({}))} {...props} />);

Footer.displayName = 'Modal.Footer';

export default Footer;
